"use strict";
/**
 * Modified From: https://github.com/kpdecker/jsdiff
 * @license BSD
 * Copyright (c) 2009-2015, Kevin Decker <kpdecker@gmail.com>
 */
export function diff(o, n) {
  const oldString = o;
  const newString = n;
  const newLen = newString.length;
  const oldLen = oldString.length;
  let editLength = 1;
  const maxEditLength = newLen + oldLen;
  const bestPath = [{ newPos: -1, components: [] }];
  const oldPos = extractCommon(bestPath[0], newString, oldString, 0);
  if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
    return [{ newValue: newString, oldValue: oldString, added: false, removed: false }];
  }
  while (editLength <= maxEditLength) {
    for (let diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
      let basePath;
      const addPath = bestPath[diagonalPath - 1];
      const removePath = bestPath[diagonalPath + 1];
      let oldPos2 = (removePath ? removePath.newPos : 0) - diagonalPath;
      if (addPath) {
        bestPath[diagonalPath - 1] = void 0;
      }
      const canAdd = addPath && addPath.newPos + 1 < newLen;
      const canRemove = removePath && 0 <= oldPos2 && oldPos2 < oldLen;
      if (!canAdd && !canRemove) {
        bestPath[diagonalPath] = void 0;
        continue;
      }
      if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
        basePath = { newPos: removePath.newPos, components: removePath.components.slice(0) };
        pushComponent(basePath.components, false, true);
      } else {
        basePath = addPath;
        basePath.newPos++;
        pushComponent(basePath.components, true, false);
      }
      oldPos2 = extractCommon(basePath, newString, oldString, diagonalPath);
      if (basePath.newPos + 1 >= newLen && oldPos2 + 1 >= oldLen) {
        return buildValues(basePath.components, newString, oldString);
      } else {
        bestPath[diagonalPath] = basePath;
      }
    }
    editLength++;
  }
  return [];
}
function pushComponent(components, added, removed) {
  const last = components[components.length - 1];
  const newCount = added ? 1 : 0;
  const oldCount = removed ? 1 : 0;
  if (last && last.added === added && last.removed === removed) {
    components[components.length - 1] = {
      newCount: last.newCount + newCount,
      oldCount: last.oldCount + oldCount,
      added,
      removed
    };
  } else if (last && last.added && removed) {
    components[components.length - 1] = {
      newCount: last.newCount + newCount,
      oldCount: last.oldCount + oldCount,
      added: true,
      removed: true
    };
  } else {
    components.push({
      newCount,
      oldCount,
      added,
      removed
    });
  }
}
function extractCommon(basePath, newString, oldString, diagonalPath) {
  const newLen = newString.length;
  const oldLen = oldString.length;
  let newPos = basePath.newPos;
  let oldPos = newPos - diagonalPath;
  let commonCount = 0;
  while (newPos + 1 < newLen && oldPos + 1 < oldLen && equals(newString.charAt(newPos + 1), oldString.charAt(oldPos + 1))) {
    newPos++;
    oldPos++;
    commonCount++;
  }
  if (commonCount) {
    basePath.components.push({
      newCount: commonCount,
      oldCount: commonCount,
      removed: false,
      added: false
    });
  }
  basePath.newPos = newPos;
  return oldPos;
}
function equals(left, right) {
  return left === right || left.toLowerCase() === right.toLowerCase();
}
function buildValues(components, newString, oldString) {
  const changes = [];
  let last = void 0;
  let newPos = 0;
  let oldPos = 0;
  for (const component of components) {
    const change = {
      newValue: newString.substring(newPos, newPos + component.newCount),
      oldValue: oldString.substring(oldPos, oldPos + component.oldCount),
      added: component.added,
      removed: component.removed
    };
    changes.push(change);
    if (last) {
      if (last.oldValue.length) {
        const lastEnd = last.oldValue.charAt(last.oldValue.length - 1);
        while (change.oldValue.length && equals(lastEnd, change.oldValue[0])) {
          last.oldValue += change.oldValue.charAt(0);
          change.oldValue = change.oldValue.substring(1);
        }
      }
      if (last.newValue.length) {
        const lastEnd = last.newValue.charAt(last.newValue.length - 1);
        while (change.newValue.length && equals(lastEnd, change.newValue[0])) {
          last.newValue += change.newValue.charAt(0);
          change.newValue = change.newValue.substring(1);
        }
      }
    }
    newPos += component.newCount;
    oldPos += component.oldCount;
    last = change;
  }
  return changes;
}
